import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { landingApi } from './api/landingApi';
import { authApi } from './api/authApi';
import { feedApi } from './api/feedApi';
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist"
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from '././slice/authSlice';  
import productReducer from '././slice/ProductSlice';  
import { productApi } from './api/productApi';
import { rentApi } from './api/rentApi';

const persistConfig = {
  key: "root",
  storage,
  blacklist: [ 
    landingApi.reducerPath],
  transforms: [],
};

const rootReducer = combineReducers({
  [landingApi.reducerPath]: landingApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [feedApi.reducerPath]: feedApi.reducer,
  [productApi.reducerPath]: productApi.reducer,
  [rentApi.reducerPath]: rentApi.reducer,
  auth: authReducer,
  product: productReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: 
        {
            // Ignorar redux-persist para evitar el error
            ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(
      landingApi.middleware,
      authApi.middleware, 
      feedApi.middleware,
      productApi.middleware,
      rentApi.middleware
    ),
});

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const persistor = persistStore(store);
